module.exports = __webpack_public_path__ + "static/img/slide-verify-02.2cfccf6c.jpg";